module.exports = __webpack_public_path__ + "static/media/arrow_back_button.76bc71e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow_back_button.svg
// module id = 1905
// module chunks = 0